import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMembersreact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "replace",
	stroke: "replace",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.7592 17H14.2367C9.13437 17 5 20.4462 5 24.6991V27H26V24.6991C26 20.4462 21.8615 17 16.7592 17Z",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 15.625,
		cy: 10.0417,
		r: 4.29167,
		strokeWidth: 1.5
	})]
});
export default SvgMembersreact;
